import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function ArticlesSection() {
  const featuredArticles = getFeaturedArticles().slice(0, 3);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-sm text-foreground-500">鬼父在线最新资讯与使用指南</p>
          </div>
          <Link
            to="/category/recommended"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-50 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(1)}万
                  </span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap items-center gap-2 mt-3">
                  {article.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/recommended"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}